// extracted by mini-css-extract-plugin
module.exports = {"titleSegment":"product-title-module--titleSegment--1sf1i","titleSegmentCourse":"product-title-module--titleSegmentCourse--2bsUw"};